import { TLang } from 'src/constants/langs'

export const getTextByLang = (
    lang: TLang,
    texts: Record<TLang, string>
): string => {
    return texts[lang] || texts['en']
}
